import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=b4f8c050&scoped=true&"
import script from "./TextInput.vue?vue&type=script&lang=js&"
export * from "./TextInput.vue?vue&type=script&lang=js&"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=b4f8c050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f8c050",
  null
  
)

export default component.exports